import { useEffect, useRef, RefObject } from 'react';

export default function useAutoScroll(steps: any): RefObject<HTMLDivElement> {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;
    requestAnimationFrame(() => {
      ref.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    });
  }, [steps]);

  return ref;
}
